
import _ from "@/boot/lodash";

import Vue, { RenderContext } from "vue";
export default Vue.extend({
  functional: true,
  render(h, context: RenderContext) {
    const scopedSlots = ["A", "B", "C"];
    const slots = _.keyBy(context.children, "data.slot") as object;
    return h(
      "div",
      _.set(context.data, "[class][cuba-columns]", true),
      _.map(
        _.filter(scopedSlots, key => slots[key]),
        (key: string) => {
          const slot = slots[key];
          return h(
            "div",
            _.set(slot.data, `[class][column-slot-${key.toLowerCase()}]`, true),
            slot.children
          );
        }
      )
    );
  }
});
